import React, {useEffect, useState} from "react";
import styles from './ToggleSwitch.module.scss';

const ToggleSwitch = ({initialState = false, onChange, id}) => {
  const toggleId = id || `toggle-switch-${Math.random().toString(36).substr(2, 9)}`;

  const [isChecked, setIsChecked] = useState(initialState);

  useEffect(() => {
    setIsChecked(initialState);
  }, [initialState]);

  const handleToggle = () => {
    const newState = !isChecked;
    setIsChecked(newState);
    if (onChange) {
      onChange(newState);
    }
  };

  return (
    <div className={styles.ToggleSwitch}>
      <input
        checked={isChecked}
        onChange={handleToggle}
        className={styles.Checkbox}
        id={toggleId}
        type="checkbox"
      />
      <label
        className={styles.Label}
        htmlFor={toggleId}
        style={{
          backgroundColor: isChecked ? '#ff9500' : '#ccc',
          transition: 'background-color 0.3s ease'
        }}
      >
        <span
          className={styles.Thumb}
          style={{transform: isChecked ? 'translateX(12px)' : 'translateX(0)'}}
        ></span>
      </label>
    </div>
  );
};

export default ToggleSwitch;
